// Avisa que s'han afegit extres a "Detalles" de la targeta de la reserva.
// "Detalles" està plegat per defecte, així que l'extra nou no es veuria:
// el botó rep un comptador (data-extras) i una animació d'avís, i la fila
// nova (quan el desplegable està obert) entra ressaltada.
//
// Tot es fa directament al DOM (atributs/classes), igual que la resta dels
// extres, perquè un re-render de React no ha de trepitjar-ho.

export const claveExtra = (sel) =>
    (sel.getAttribute("data-habitacion") ?? "") + "|" + (sel.getAttribute("data-extraid") ?? sel.getAttribute("data-nombre"));

const sinMovimiento = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// `previasRef.current` és null fins al primer càlcul: els extres que ja hi
// ha en carregar la pàgina (obligatoris) no compten com a "nous".
export const avisarExtrasNuevos = (selects, previasRef) => {
    const claves = new Set(selects.map(claveExtra));
    const previas = previasRef.current;
    const nuevos = previas === null ? new Set() : new Set([...claves].filter((c) => !previas.has(c)));
    previasRef.current = claves;

    document.querySelectorAll(".bh-cart__details").forEach((btn) => {
        const hab = btn.getAttribute("data-hab");
        const propios = selects.filter((sel) =>
            hab === null || !sel.hasAttribute("data-habitacion") || sel.getAttribute("data-habitacion") === hab
        );
        btn.setAttribute("data-extras", propios.length);

        if (propios.some((sel) => nuevos.has(claveExtra(sel))) && !sinMovimiento()) {
            btn.classList.remove("bh-cart__details--aviso");
            void btn.offsetWidth; // reinicia l'animació si es repeteix
            btn.classList.add("bh-cart__details--aviso");
        }
    });

    // Extres retirats: el comptador "baixa" (mateix avís, to més suau)
    const quitados = previas === null ? new Set() : new Set([...previas].filter((c) => !claves.has(c)));
    if (quitados.size && !nuevos.size && !sinMovimiento()) {
        document.querySelectorAll(".bh-cart__details").forEach((btn) => {
            btn.classList.remove("bh-cart__details--baja");
            void btn.offsetWidth;
            btn.classList.add("bh-cart__details--baja");
        });
    }

    return nuevos;
};

// Files retirades del desplegable: es deixa una còpia que s'encongeix i
// s'esvaeix (cont.innerHTML es reescriu a cada canvi, així que altrament
// l'extra desapareixeria de cop).
export const salidaFilasExtras = (cont, viejas) => {
    if (sinMovimiento()) return;
    const ahora = new Set([...cont.querySelectorAll(".bh-cart__extra[data-clave]")].map((f) => f.getAttribute("data-clave")));
    viejas.forEach((fila, i) => {
        if (ahora.has(fila.getAttribute("data-clave"))) return;
        const copia = fila.cloneNode(true);
        copia.classList.remove("bh-cart__extra--nuevo");
        copia.classList.add("bh-cambio-sale");
        copia.setAttribute("aria-hidden", "true");
        copia.removeAttribute("data-clave");
        cont.insertBefore(copia, cont.children[i] || null);
        copia.style.setProperty("--bh-alto", copia.offsetHeight + "px");
        copia.addEventListener("animationend", () => copia.remove(), { once: true });
        setTimeout(() => copia.remove(), 1500);
    });
};
